import { makeAutoObservable } from 'mobx'

class Sorter {
    constructor(sortField, sortSense) {
        this.sortField = sortField
        this.sortSense = sortSense

        makeAutoObservable(this)
    }

    setSort(sortField, sortSense) {
        this.sortField = sortField
        this.sortSense = sortSense
    }

    changeSort(sortField) {
        let sortSense = 'ASC'

        if (sortField === this.sortField && this.sortSense === 'ASC') {
            sortSense = 'DESC'
        }

        this.sortField = sortField
        this.sortSense = sortSense
    }

    get isASC() {
        return this.sortSense === 'ASC'
    }

    static fromJson({ sortField, sortSense }) {
        return new Sorter(sortField, sortSense)
    }

    static empty() {
        return new Sorter('', '')
    }
}

export default Sorter
